import Node from './Node';
import StringUtil from '@/util/StringUtil';

export enum ConnectionDirection
{
    // eslint-disable-next-line no-unused-vars
    Forward = 0,
    // eslint-disable-next-line no-unused-vars
    Backward = 1,
    // eslint-disable-next-line no-unused-vars
    Bidirectional = 2,
    // eslint-disable-next-line no-unused-vars
    None = 3,
}

export default class Connection
{
    public nodeid1 : number;
    public nodeid2 : number;
    public description : string;
    public references : string;
    public direction : ConnectionDirection = ConnectionDirection.Forward;

    /** A constructor that encapsulates the id ordering in the Connection. All parameters are optional.
     */ 
    public constructor(
        id1 : number = -1,
        id2 : number = -1,
        description : string = "",
        references : string = "",
        direction : ConnectionDirection = ConnectionDirection.Forward)
    {
        if (id1 > id2)
        {
            this.nodeid1 = id2;
            this.nodeid2 = id1;
        }
        else
        {
            this.nodeid1 = id1;
            this.nodeid2 = id2;
        }
        this.description = description;
        this.references = references;
        this.direction = direction;
    }

    public addToCSV(csv : string, nodes : Map<number, Node>) : string
    {
        const n1 = nodes.get(this.nodeid1);
        const n2 = nodes.get(this.nodeid2);
        const name1 = ((n1 != null) ? n1.name : '');
        const name2 = ((n2 != null) ? n2.name : '');
        let arrow = '->';
        switch (this.direction)
        {
        case ConnectionDirection.Forward: arrow = '->'; break;
        case ConnectionDirection.Backward: arrow = '<-'; break;
        case ConnectionDirection.Bidirectional: arrow = '<->'; break;
        case ConnectionDirection.None: arrow = '-'; break;
        default: arrow = '->'; break;
        }
        const escName = StringUtil.csvEscapeString(`${name1} ${arrow} ${name2}`);
        const typeString = '"connection"';
        const escDescription = StringUtil.csvEscapeString(this.description);
        const escReferences = StringUtil.csvEscapeString(this.references);
        
        csv += '\n';
        csv += `${escName},${typeString},${escDescription},${escReferences},"","","","","","",""`;
        return csv;
    }
}